export default "__VITE_PUBLIC_ASSET__0039f643__"